import api from '@/api/role'

const state = {
    item: null,
    items: [],
    pagination: null,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
        console.log('deleted item at index ' + index)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    create(context, payload) {
        return api.create(payload).then(() => {})
    },
    fetch(context, payload) {
        return api
            .fetch(payload.query, payload.page)
            .then(
                ({
                    data: {
                        success: { data: pag },
                    },
                }) => {
                    let items = pag.data

                    context.commit('set', items)
                    //let pag = result.data.success.data
                    context.commit('set_pagination', {
                        page: pag.current_page,
                        pageSize: pag.per_page,
                        total: pag.total,
                    })
                }
            )
            .catch(err => {
                throw err
            })
    },

    fetchAll(context) {
        return api
            .fetchAll()
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('role data', data)
                    context.commit('set', data)
                }
            )
            .catch(err => {
                throw err
            })
    },
    fetchById(context, id) {
        console.log('id', id)
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('assumed role', data)
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                throw err
            })
    },
    update(context, payload) {
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        console.log('deleting')
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                throw err
            })
    },
}

const getters = {
    roles(state) {
        return state.items
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
